import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router
import store from './store';

// Ensure browser tab title is set at runtime.
document.title = 'Zima';


createApp(App)
  .use(router) // Use the router
  .use(store)
  .mount('#app');
